import {doGet, doPost} from "../base";

const DEVICES_URL = (deviceId = "", retrieveAll=false) => `/user_auth/devices${deviceId !== "" ? `/${deviceId}` : ""}${retrieveAll ? '/assignment': ""}`;

const SET_DAFAULTS = ({imeiNumbers, limit, pager, serialNumbers, simNumbers, sortField, sortOrder, triggeredAtStartDate, triggeredAtEndDate}) => {
    let params = [];
    if (imeiNumbers) {
        const imeiNumbersComma = imeiNumbers.replace(/\s+/g, ',')
        params.push("imeiNumbers=" + imeiNumbersComma)
    }
    if (limit) {
        params.push("limit=" + limit);
    }
    if (pager) {
        params.push("page=" + pager);
    }
    if (serialNumbers) {
        const serialNumbersComma = serialNumbers.replace(/\s+/g, ',')
        params.push("serialNumbers=" + serialNumbersComma)
    }
    if (simNumbers) {
        const simNumbersComma = simNumbers.replace(/\s+/g, ',')
        params.push("simNumbers=" + simNumbersComma)
    }
    if (sortField) {
        params.push("sortField=" + sortField);
    }
    if (sortOrder) {
        params.push("sortOrder=" + sortOrder);
    }
    if (triggeredAtStartDate && triggeredAtEndDate) {
        params.push("dateTime=" + `${triggeredAtStartDate},${triggeredAtEndDate}`)
    }
    return params;
}

export const doPostCreateManufacturingDevices = async (devices) => {
    if (!devices) {
        throw new Error("device cannot be null")
    }
    let deviceInfo = devices.map(device => {
        const {message, ...rest} = device
        return rest
    })
    const url = DEVICES_URL("") + "/manufacturing/add/devicesV3";
    return await doPost({deviceInfo},url).catch((error) => {
        throw error
    })
}

export const editManufacturingDevice = async (device) => {
    const deviceInfo = device.device
    deviceInfo.IMEI = deviceInfo.imei
    deviceInfo.SIMNumber = deviceInfo.simNumber
    if (!device) {
        throw new Error("device cannot be null")
    }
    const url = DEVICES_URL("") + "/manufacturing/update/devicesV3";
    return await doPost(deviceInfo,url).catch((error) => {
        throw error
    })
}

export const getManufacturingDevices = async ({imeiNumbers, limit, pager, serialNumbers, simNumbers, sortField, sortOrder, triggeredAtStartDate, triggeredAtEndDate}) => {
    let url = DEVICES_URL("") + "/manufacturing/devicesV3"
    let params = SET_DAFAULTS({imeiNumbers, limit, pager, serialNumbers, simNumbers, sortField, sortOrder, triggeredAtStartDate, triggeredAtEndDate})
    for (let i = 0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i]
    }
    return await doGet(url).catch((error) => {
        throw error
    })
}

export const getAllManufacturingDevices = async () => {
    let url = DEVICES_URL("") + "/manufacturing/fetch/allDevicesV3"
    return await doGet(url).catch((error) => {
        throw error
    })
}

